import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  Chip,
  CardMedia,
  MenuItem,
  Snackbar,
  Alert
} from "@mui/material";
import { vendorApi } from "../../api/api";
import { useNavigate } from "react-router-dom";

const EditFlatDetails = ({ open, flat, apartmentId, onClose }) => {
  console.log(flat, apartmentId);
  debugger
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const [displayImage, setDisplayImage] = useState(null);
  const [existingImages, setExistingImages] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);

  const navigate = useNavigate()
  useEffect(() => {
    if (flat) {
      setForm(flat);
      setDisplayImage(null);
      setExistingImages(flat.Images || []);
      setGalleryImages([]);
      setRemovedImages([]);
    }
  }, [flat]);



  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRemoveExistingImage = (img) => {
    setExistingImages(existingImages.filter(i => i !== img));
    setRemovedImages([...removedImages, img]);
  };

  const handleRemoveNewImage = (index) => {
    setGalleryImages(galleryImages.filter((_, i) => i !== index));
  };


  const handleSave = async () => {
    try {
      setSaving(true);

      const formData = new FormData();

      // Required
      formData.append("FlatId", form.Id);
      formData.append("ApartmentId", apartmentId); // VERY IMPORTANT
      formData.append("FlatName", form.FlatName);
      formData.append("FlatType", form.FlatType);

      // Optional fields
      formData.append("FloorNo", form.FloorNo ?? "");
      formData.append("Facing", form.Facing ?? "");
      formData.append("SizeInSqFt", form.SizeInSqFt ?? "");
      formData.append("Price", form.Price ?? "");
      formData.append("PriceType", form.PriceType ?? "");
      formData.append("Status", form.Status ?? "");

      // Display Image
      if (displayImage) {
        formData.append("DisplayImage", displayImage);
      }

      // Removed gallery images
      removedImages.forEach((img) => {
        formData.append("RemovedImages[]", img);
      });

      // New gallery images
      galleryImages.forEach((file) => {
        formData.append("NewImages[]", file);
      });
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      debugger
      await vendorApi.editFlat(formData);

      setSnackbar({
        open: true,
        message: "Flat updated successfully",
        severity: "success",
      });

      setSnackbar({
        open: true,
        message: "Flat updated successfully",
        severity: "success",
      });

      setTimeout(() => {
        onClose();
        window.location.reload();
      }, 1500); // 0.8 sec is enough

    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Failed to update flat",
        severity: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  const size = Number(form.SizeInSqFt || 0);
  const price = Number(form.Price || 0);

  const calculatedTotalPrice =
    form.PriceType === "PerSqFt" && size && price
      ? size * price
      : 0;

  const calculatedPerSqFtPrice =
    form.PriceType === "Total" && size && price
      ? price / size
      : 0;

  if (!flat) return null;

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Edit Flat – {flat.FlatName}</DialogTitle>

        <DialogContent dividers>
          {/* Display Image */}
          <Box mb={3}>
            <Typography variant="subtitle2" gutterBottom>
              Display Image
            </Typography>

            <CardMedia
              component="img"
              height="220"
              image={
                displayImage
                  ? URL.createObjectURL(displayImage)
                  : flat.DisplayImage
              }
              sx={{ borderRadius: 2, mb: 1 }}
            />

            <Button variant="outlined" component="label">
              Change Display Image
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => setDisplayImage(e.target.files[0])}
              />
            </Button>
          </Box>


          {/* Basic Info */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Flat Name"
                name="FlatName"
                value={form.FlatName || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Flat Type"
                name="FlatType"
                value={form.FlatType || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Floor No"
                name="FloorNo"
                value={form.FloorNo || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Facing"
                name="Facing"
                value={form.Facing || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Size (sq.ft)"
                name="SizeInSqFt"
                value={form.SizeInSqFt || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                label="Price Type"
                name="PriceType"
                value={form.PriceType || ""}
                onChange={handleChange}
                fullWidth
              >
                <MenuItem value="PerSqFt">Per Sq Ft</MenuItem>
                <MenuItem value="Total">Total</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label={
                  form.PriceType === "PerSqFt"
                    ? "Price (Per Sq Ft)"
                    : form.PriceType === "Total"
                      ? "Total Price"
                      : "Price"
                }
                name="Price"
                value={form.Price || ""}
                onChange={handleChange}
                fullWidth
                type="number"
              />
            </Grid>

            <Grid item xs={12}>
              {form.PriceType === "PerSqFt" && size > 0 && price > 0 && (
                <Box
                  sx={{
                    mt: 1,
                    p: 1.5,
                    borderRadius: 1,
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  <Typography variant="subtitle2" color="green">
                    💰 Total Price: ₹ {calculatedTotalPrice.toLocaleString()}
                  </Typography>
                </Box>
              )}

              {form.PriceType === "Total" && size > 0 && price > 0 && (
                <Box
                  sx={{
                    mt: 1,
                    p: 1.5,
                    borderRadius: 1,
                    backgroundColor: "#e3f2fd",
                  }}
                >
                  <Typography variant="subtitle2" color="primary">
                    📐 Per Sq Ft Price: ₹ {calculatedPerSqFtPrice.toFixed(2)}
                  </Typography>
                </Box>
              )}
            </Grid>







            <Grid item xs={6}>
              <TextField
                select
                label="Status"
                name="Status"
                value={form.Status || ""}
                onChange={handleChange}
                fullWidth
              >
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Sale Initiated">Sale Initiated</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          {/* Gallery Images (View Only) */}
          {/* {flat.Images?.length > 0 && ( */}
            <Box mt={4}>
              <Typography variant="subtitle2" gutterBottom>
                Gallery Images
              </Typography>

              <Grid container spacing={2}>
                {/* Existing Images */}
                {existingImages.map((img, i) => (
                  <Grid item xs={6} sm={4} md={3} key={`existing-${i}`}>
                    <Box position="relative">
                      <CardMedia
                        component="img"
                        height="120"
                        image={img}
                        sx={{ borderRadius: 1 }}
                      />
                      <Button
                        size="small"
                        color="error"
                        variant="contained"
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          minWidth: "auto",
                          px: 1
                        }}
                        onClick={() => handleRemoveExistingImage(img)}
                      >
                        ✕
                      </Button>
                    </Box>
                  </Grid>
                ))}

                {/* New Images Preview */}
                {galleryImages.map((file, i) => (
                  <Grid item xs={6} sm={4} md={3} key={`new-${i}`}>
                    <Box position="relative">
                      <CardMedia
                        component="img"
                        height="120"
                        image={URL.createObjectURL(file)}
                        sx={{
                          borderRadius: 1,
                          border: "2px dashed #4caf50"
                        }}
                      />
                      <Button
                        size="small"
                        color="error"
                        variant="contained"
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          minWidth: "auto",
                          px: 1
                        }}
                        onClick={() => handleRemoveNewImage(i)}
                      >
                        ✕
                      </Button>
                    </Box>
                  </Grid>
                ))}

                {/* Empty State */}
                {existingImages.length === 0 && galleryImages.length === 0 && (
                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                      No gallery images added yet.
                    </Typography>
                  </Grid>
                )}
              </Grid>

              {/* ✅ ALWAYS VISIBLE BUTTON */}
              <Button
                variant="outlined"
                component="label"
                sx={{ mt: 2 }}
              >
                Add Gallery Images
                <input
                  type="file"
                  hidden
                  multiple
                  accept="image/*"
                  onChange={(e) =>
                    setGalleryImages([
                      ...galleryImages,
                      ...Array.from(e.target.files),
                    ])
                  }
                />
              </Button>
            </Box>



          {/* )} */}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditFlatDetails;
